module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_01_sp-84a12c0773dc2f63519b5f9b5ca0d58d.png";